import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Form, Icon, Input, Button,
} from 'antd';
import { forgotPasswordRequest } from '../redux/actions/account_actions/forgot_password.actions';
import { validation_rules } from '../../../shared/validation_rules';
import { WelcomeTitle } from './WelcomeTitle';

const mapStateToProps = (state) => {
    const { isSendingEmail, hasSentEmail } = state.App.Forgot_password_form;
    return { isSendingEmail, hasSentEmail };
}; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class ForgotPasswordForm extends Component {
  state = {
      email: '',
      confirm_email: '',
  };

  handleChange = (name, value) => this.setState({ [name]: value });

  handleSubmit = (event) => {
      event.preventDefault();
      this.props.dispatch(forgotPasswordRequest(this.state.confirm_email));
  };

  render() {
      const { email, confirm_email } = this.state; const
          { isSendingEmail } = this.props;
      if (isSendingEmail) return null;
      return !this.props.hasSentEmail
          ? (
              <div className="account">
                  <div className="account__wrapper">
                      <div className="account__card">
                          <WelcomeTitle>
                              <h4 className="account__subhead subhead">Please enter your email address below to reset your password</h4>
                          </WelcomeTitle>
                          <Form onSubmit={this.handleSubmit} className="login-form">
                              <FormItem label="Email Address">
                                  <Input
                                      value={email}
                                      maxLength={50}
                                      type="email"
                                      prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      placeholder="Email Address"
                                      onChange={event => this.handleChange('email', event.target.value)}
                                  />
                              </FormItem>
                              <span className="validationError">{email && validation_rules.email(email)}</span>
                              <FormItem label="Confirm Email Address">
                                  <Input
                                      value={confirm_email}
                                      maxLength={50}
                                      type="email"
                                      prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                      placeholder="Confirm Email Address"
                                      onChange={event => this.handleChange('confirm_email', event.target.value)}
                                  />
                              </FormItem>
                              <span className="validationError">{confirm_email && validation_rules.emailMatching(email, confirm_email)}</span>
                              <FormItem className="btnWrapper">
                                  <Button
                                      type="primary"
                                      loading={isSendingEmail}
                                      style={{ width: '100%' }}
                                      disabled={!(!validation_rules.email(email) && !validation_rules.emailMatching(email, confirm_email) && email && confirm_email)}
                                      htmlType="submit"
                                  >
                                      Request Password
                                  </Button>
                              </FormItem>
                              <p className="text-align-center authText">
                                  Remembered Password?
                                  <Link to="/login">Click here to login</Link>
                              </p>
                          </Form>
                      </div>
                  </div>
              </div>
          )
          : (
              <div className="account forgotPassword">
                  <div className="account__wrapper">
                      <div className="account__card">
                          <WelcomeTitle>
                              <h4 className="account__subhead subhead">You have been sent an email to reset your password</h4>
                          </WelcomeTitle>
                          <p>
                              You have been sent a secure link to
                              {this.state.email}
                              .
                          </p>
                          <p>Please click on this link and reset your password. The link will be valid for 20 minutes.</p>
                          <p><Link to="/login">Back to Login</Link></p>
                      </div>
                  </div>
              </div>
          );
  }
});



// WEBPACK FOOTER //
// ./src/modules/App/components/ForgotPasswordForm.js